import { defineMessages } from "react-intl";

/** Labels of the wrap-up form fields, shared by the fields and their validation messages. */
export const FIELD_LABELS = defineMessages({
  jobTitle: {
    defaultMessage: "Job Title",
    description:
      "Label of the job title field on the post-meeting wrap-up form.",
  },
  currentCompany: {
    defaultMessage: "Current Company",
    description:
      "Label of the current company field on the post-meeting wrap-up form.",
  },
  notes: {
    defaultMessage: "Notes",
    description:
      "Label of the recruiter notes field on the post-meeting wrap-up form.",
  },
  summary: {
    defaultMessage: "Summary",
    description:
      "Label of the meeting summary field on the post-meeting wrap-up form.",
  },
  skills: {
    defaultMessage: "Skills",
    description: "Label of the skills field on the post-meeting wrap-up form.",
  },
  skillsComments: {
    defaultMessage: "Skill Comments",
    description:
      "Label of the skill comments field on the post-meeting wrap-up form.",
  },
  goalsAndInterests: {
    defaultMessage: "Goals & Interests",
    description:
      "Label of the goals and interests field on the post-meeting wrap-up form.",
  },
  locationComments: {
    defaultMessage: "Geographic Preferences Comments",
    description:
      "Label of the geographic preferences comments field on the post-meeting wrap-up form.",
  },
});

/** Buttons shared by the wrap-up dialogs. */
export const DIALOG_ACTIONS = defineMessages({
  confirm: {
    defaultMessage: "Confirm",
    description: "Button that accepts a confirmation dialog.",
  },
  cancel: {
    defaultMessage: "Cancel",
    description: "Button that dismisses a confirmation dialog without acting.",
  },
  close: {
    defaultMessage: "Close",
    description: "Button that closes a dialog or panel.",
  },
});
